import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import FormikControl from "../../components/form/formikControl";
import { Row, FormContainer } from "../../components/form/alignment";

import {
  ServicesContainer,
  PlusTopServicesContainer,
  ServicesImageContainer,
  ServicesFormContainer,
  FormWrapper,
  PlusServicesContainer,
} from "./index.styled";
import { TextContainer } from "../../pages/landing/index.styled";
import { CustomButton } from "../buttons/index.styled";
import PhoneImg from "../../assets/images/Phone.svg";
import userIcon from "../../assets/icons/user.svg";
import PhoneIcon from "../../assets/icons/call-calling.png";
import textAreaIcon from "../../assets/icons/textalign-justifyright.png";
import emailIcon from "../../assets/icons/emailIcon.png";
import bluePlus from "../../assets/images/bluePlus.png";
import yellowPlus from "../../assets/images/yellowPlus.png";
import { postContactUs } from "../../services/cantactUsAPI";
import { toast } from "react-toastify";

const Contacts = () => {

  const initialValues = {
    phoneNumber: "",
    nickname: "",
  };

  const validationSchema = Yup.object({
    phoneNumber: Yup.number()
      .required("شماره تلفن الزامی می‌باشد")
      .typeError("شماره تلفن نباید کاراکتر باشد"),
    email: Yup.string()
      .email("ایمیل نامعتبر است.")
      .required("ایمیل الزامی می باشد."),
    description: Yup.string().required("توضیحات الزامی است"),
    nickname: Yup.string().required("نام الزامی است"),
  });

  const onSubmit = async (values, { resetForm }) => {

    const obj = {
      fullName : values.nickname,
      mobile : values.phoneNumber,
      email : values.email,
      text : values.description
    };

      const response =  await postContactUs(obj);
      
      if(response.type) {
        toast.success("درخواست شما با موفقیت ارسال شد.");
        resetForm();
      } else {
        toast.error(response.message);
      };

  };
  return (
    <ServicesContainer id="contacts">
      <PlusTopServicesContainer>
        <div>
          <img src={bluePlus} alt="blue plus" />
        </div>
        <div>
          <img src={yellowPlus} alt="yellow plus" />
        </div>
      </PlusTopServicesContainer>

      <ServicesImageContainer>
        <img src={PhoneImg} alt="phone" />
      </ServicesImageContainer>
      <ServicesFormContainer>
        <h2>درخواست سرویس آواشو</h2>
        <TextContainer defP='5rem' maxv="490px">
          <p>
            برای استفاده از سرویس آواشو در اپلیکیشن‌ها و وبسایت‌های سازمانی خود
            می‌توانید از طریق فرم زیر با ما در ارتباط باشید.
          </p>
        </TextContainer>
        <FormWrapper>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => {
              return (
                <FormContainer>
                  <Form>
                    <Row columnGap="0px" marginBottom="10px">
                      <FormikControl
                        control="input"
                        name="nickname"
                        type="text"
                        placeholder="نام و نام خانوادگی"
                        rightIcon={userIcon}
                        width="620px"
                      />
                    </Row>
                    <Row
                      columnGap="20px"
                      marginBottom="10px"
                      className="row-wrapper"
                      break={true}
                    >
                      <FormikControl
                        control="input"
                        name="phoneNumber"
                        placeholder="شماره تماس"
                        rightIcon={PhoneIcon}
                        width="300px"
                      />
                      <FormikControl
                        control="input"
                        name="email"
                        placeholder="ایمیل"
                        rightIcon={emailIcon}
                        width="300px"
                      />
                    </Row>
                    <Row columnGap="20px" marginBottom="10px">
                      <FormikControl
                        control="textarea"
                        name="description"
                        placeholder="متن پیام"
                        width="620px"
                        rightIcon={textAreaIcon}
                      />
                    </Row>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        marginTop: "30px",
                      }}
                      className="button-container"
                    >
                      <CustomButton type="submit" disabled={!formik.isValid}>
                        ارسال
                      </CustomButton>
                    </div>
                  </Form>
                </FormContainer>
              );
            }}
          </Formik>
        </FormWrapper>
      </ServicesFormContainer>

      <PlusServicesContainer>
        <div>
          <img src={bluePlus} alt="bluePlus" />
        </div>
        <div>
          <img src={yellowPlus} alt="yellowPlus" />
        </div>
      </PlusServicesContainer>
    </ServicesContainer>
  );
};

export default Contacts;
